import { useEffect, useState } from 'react';
const getWindowDimensions = () => ({
    width: window.visualViewport?.width || document.documentElement.clientWidth,
    height: window.visualViewport?.height || document.documentElement.clientHeight,
});
export function useVisualViewport() {
    const [viewport, setViewport] = useState();
    useEffect(() => {
        const updateViewport = () => {
            setViewport(getWindowDimensions());
        };
        window.addEventListener('resize', updateViewport, { passive: true });
        window.visualViewport?.addEventListener('resize', updateViewport, { passive: true });
        updateViewport();
        return () => {
            window.removeEventListener('resize', updateViewport);
            window.visualViewport?.removeEventListener('resize', updateViewport);
        };
    }, []);
    return viewport;
}
